import React, { Component } from "react";
import CustomerMyBooks from "./CustomerMyBooks/CustomerMyBooks";
import AuthorMyBooks from "./AuthorMyBooks/AuthorMyBooks";

class MyBooks extends Component {
  render() {
    return (
      <div>
        {this.props.match.params.type === "Author" ? (
          <AuthorMyBooks />
        ) : (
          <CustomerMyBooks />
        )}
      </div>
    );
  }
}

export default MyBooks;
